import React from "react";
import { Box } from "@mui/material";
import { ProductId } from "../product";
import BusinessBaseFormSection from "./BusinessBaseFormSection";
import CareBusinessSettingsForm from "../../../products/care/forms/CareBusinessSettingsForm";

type Props = {
  productId: ProductId;
  baseFormProps: any;
  careFormProps: any;
  bookingFormProps: any;
};

export default function BusinessSettingsPage({
  productId,
  baseFormProps,
  careFormProps,
  bookingFormProps,
}: Props): JSX.Element {
  return (
    <Box sx={{ width: "100%", mx: "auto", px: 2 }}>
      <BusinessBaseFormSection {...baseFormProps} productId={productId} />
      <CareBusinessSettingsForm {...careFormProps} />
    </Box>
  );
}
